import hitungSablon from "../../utils/harga-sablon";
import { format } from "date-fns";
import { id as indo } from "date-fns/locale";

export default function receipt(data, total, qr) {
  const dataPesanan = data || {};
  const total_dibayar = total || 0;

  const semuaPesanan = dataPesanan?.pesanan
    ?.map((psn, index) => {
      const _subtotal = Object.keys(psn.produk)
        .map((el) => {
          const _sablon = Object.keys(psn.jasa)
            .map((s) => hitungSablon(psn.jasa[s].panjang, psn.jasa[s].lebar))
            .reduce((a, b) => a + b, 0);
          const _data = psn.produk[el];
          const _harga = Number(_data.harga) + Number(_sablon);
          return (Number(_harga || 0) - _data.potongan) * _data.jumlah;
        })
        .reduce((c, d) => c + d, 0);

      return `<div class="pesanan">PESANAN  ${index + 1}</div>
              ${Object.keys(psn.produk)
                .map((p) => {
                  const _data = psn.produk[p];
                  const _sablon = Object.keys(psn.jasa)
                    .map((s) =>
                      hitungSablon(psn.jasa[s].panjang, psn.jasa[s].lebar)
                    )
                    .reduce((a, b) => a + b, 0);
                  const _harga =
                    Number(_data.harga) -
                    Number(_data.potongan) +
                    Number(_sablon);

                  return `
                  <div class="row">
                  <div class="start nama">${_data.nama}, ${
                    _data.data.warna || "Warna"
                  } ${_data.data.ukuran || "Ukuran"}</div>
                  <div class="center jumlah">×${_data.jumlah}</div>
                  <div class="end harga">${new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumSignificantDigits: 10,
                  }).format(_harga)}</div>
                </div>`;
                })
                .join("\n")}

                <div class="row subtotal">
      <div class="start nama">Subtotal</div>
      <div class="end harga">${new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumSignificantDigits: 10,
      }).format(_subtotal)}</div>
    </div>`;
    })
    .join("\n");

  const pembayaran =
    dataPesanan?.pembayaran?.dibayar < total_dibayar
      ? `<div class="row">
    <div class="start">Dibayar</div>
    <div class="end">${new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumSignificantDigits: 10,
    }).format(dataPesanan?.pembayaran?.dibayar)}</div>
  </div>
  <div class="row">
  <div class="start">Tersisa</div>
  <div class="end">${new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumSignificantDigits: 10,
  }).format(
    Number(total_dibayar) - Number(dataPesanan?.pembayaran?.dibayar)
  )}</div>
</div>`
      : `<div class="lunas">LUNAS</div>`;

  return `
<!DOCTYPE html>
<html lang="id">
<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Transaksi ${dataPesanan?.id}</title>

  <style>
    html,
    body {
      padding: 0;
      margin: 0 auto;
      font-family: 'Arial', sans-serif;
      font-size: 14px;
      max-width: 2in;
    }

    .receipt {
      width: 2in;
      text-align: center;
      padding: 1em 0 1em 0;
      font-size: 12px;
    }

    .title {
      margin-top: .5em;
      font-size: 16px;
      font-weight: bold;
    }

    .border {
      border: solid 2px;
      padding: 0.3em;
    }

    .pesan {
      text-align: center;
      margin: 1em auto;
      border: solid 1px;
      padding: 0.3em;
      border-radius: 5px;
    }

    .sosmed {
      border-top: solid 1px;
      font-size: .9em;
    }

    .trxid {
      margin: .3em auto;
      width: max-content;
      font-weight: bold;
      font-size: 14px;
    }

    .row {
      font-size: 11px;
      display: flex;
      justify-content: space-between;
      margin: 0.3em 0;
      align-items: center;
    }

    .start {
      text-align: left;
    }

    .center {
      text-align: center;
    }

    .end {
      text-align: right;
    }

    .pesanan {
      margin-top: 1em;
      font-size: 12px;
      font-weight: bold;
      border-bottom: dashed 1px;
      border-top: dashed 1px;
    }
    .nama {
      flex: 45%;
      padding-right: 0.5em;
    }
    .jumlah {
      flex: 5%;
    }

    .harga {
      flex: 45%;
      padding-left: 0.5em;
    }

    .subtotal {
      font-weight: bold;
    }

    .lunas{
      width: 6em;
      margin: auto;
      padding: .3em;
      font-weight: bold;
      border: solid 2px;
      border-radius: .3em;
    }

    .total {
      border-bottom: dashed 1px;
      border-top: dashed 1px;
      font-size: 18px;
      font-weight: bold;
    }

    .info {
      margin: 1em auto;
      font-size: 0.9em;
      word-wrap: break-word;
    }

    @page {
      margin: .1in !important;
    }

    @media print {
      html,
      body {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  </style>
</head>
<body>
  <div class="receipt">
  <div style="text-align: right;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 43"
      width="60px"
    >
      <path d="M99.5 31.367a11.526 11.526 0 01-4.559 1.716l-9.087-7.753v7.891h-4.271V1.101h4.271v16.213l7.496-7.659c1.741.019 3.388.426 4.866 1.133L87.833 21.403 99.5 31.367zM35.209 9.627V33.2h-11.6c-6.453 0-11.701-5.237-11.701-11.69v-.193c0-6.442 5.249-11.69 11.701-11.69h11.6zm-4.272 4.26h-7.328c-4.101 0-7.43 3.34-7.43 7.43v.193a7.433 7.433 0 007.43 7.43H30.937V13.887zM12.644 28.96h-.442a7.433 7.433 0 01-7.43-7.43v-7.624h4.397v-4.26H4.772V5.375H.5V21.531c0 6.453 5.249 11.69 11.701 11.69h5.206a13.378 13.378 0 01-4.763-4.261zm42.493-3.695c-1.288 2.206-3.672 3.695-6.41 3.695h-5.854v4.26h5.855c3.375 0 6.411-1.441 8.548-3.731a13.207 13.207 0 01-2.139-4.224zM79.458 9.646H67.859c-3.374 0-6.409 1.443-8.546 3.733a13.197 13.197 0 012.137 4.225c1.288-2.205 3.672-3.698 6.409-3.698h7.884V28.96h-7.884a7.433 7.433 0 01-7.43-7.43v-.194c0-6.441-5.249-11.69-11.701-11.69H37.128V41.764H41.4V13.907h7.328c4.101 0 7.43 3.34 7.43 7.43v.194c0 6.453 5.249 11.69 11.701 11.69h6.306V33.2h1.578v.02h4.272V9.646h-.557z"></path>
      <path d="M52.379 35.392a.538.538 0 01.378-.13.54.54 0 01.378.13.44.44 0 01.143.34.44.44 0 01-.143.34.538.538 0 01-.378.13.54.54 0 01-.378-.13.44.44 0 01-.143-.34.441.441 0 01.143-.34zm.755 1.69v4.606h-.763v-4.606h.763zM58.923 37.522c.33.344.495.84.495 1.489v2.676h-.763v-2.609c0-.458-.117-.811-.352-1.057-.235-.246-.554-.369-.956-.369-.419 0-.755.136-1.007.407-.252.271-.378.667-.378 1.187v2.441h-.763v-4.606h.763v1.091c.117-.375.326-.663.625-.864a1.815 1.815 0 011.036-.302c.536.001.97.173 1.3.516zM64.455 37.359c.31.224.527.523.65.898V35.48h.763v6.208h-.763v-1.174c-.123.375-.34.674-.65.898-.31.224-.689.336-1.137.336-.408 0-.772-.095-1.091-.285a1.973 1.973 0 01-.751-.818c-.182-.355-.273-.773-.273-1.254s.091-.9.273-1.258c.182-.358.432-.632.751-.822a2.09 2.09 0 011.091-.285c.448-.003.827.109 1.137.333zm-2.047.793c-.282.299-.424.712-.424 1.237 0 .526.141.938.424 1.237.282.299.659.449 1.128.449.302 0 .572-.07.81-.21a1.46 1.46 0 00.558-.591 1.87 1.87 0 00.201-.885c0-.336-.067-.632-.201-.889a1.423 1.423 0 00-.558-.591 1.594 1.594 0 00-.81-.206c-.469 0-.845.15-1.128.449zM72.018 37.082v4.606h-.763v-1.082a1.549 1.549 0 01-.625.86 1.84 1.84 0 01-1.044.298c-.531 0-.962-.172-1.292-.516-.33-.344-.495-.837-.495-1.481v-2.684h.763v2.609c0 .459.117.812.352 1.061.235.249.554.373.956.373.419 0 .755-.136 1.007-.407.252-.271.378-.667.378-1.187v-2.45h.763zM76.779 37.43c.316.271.508.636.575 1.095h-.73a1.058 1.058 0 00-.34-.675c-.193-.176-.452-.264-.776-.264-.274 0-.488.066-.642.197a.664.664 0 00-.231.533c0 .168.052.303.155.407a.984.984 0 00.386.235c.154.053.365.11.633.172.341.078.617.158.826.239.21.081.389.211.537.39.148.179.222.419.222.721 0 .375-.141.679-.424.914-.282.235-.659.352-1.128.352-.548 0-.996-.131-1.342-.394-.347-.263-.551-.629-.612-1.099h.738c.028.28.15.506.365.68.215.173.499.26.851.26.263 0 .468-.067.617-.201a.68.68 0 00.222-.529.579.579 0 00-.159-.428 1.05 1.05 0 00-.394-.243 5.673 5.673 0 00-.646-.176 6.304 6.304 0 01-.818-.235 1.252 1.252 0 01-.52-.373c-.143-.171-.214-.401-.214-.692 0-.386.143-.698.428-.935.285-.238.674-.357 1.166-.357.521-.001.939.135 1.255.406zM81.455 41.016v.671h-.57c-.47 0-.821-.112-1.053-.336-.232-.224-.348-.598-.348-1.124v-2.483h-.688v-.663h.688v-1.149h.772v1.149h1.191v.663h-1.191v2.5c0 .297.055.499.164.608.109.109.298.164.566.164h.469zM84.652 37.271c.291-.176.638-.264 1.04-.264v.831h-.235c-.431 0-.783.11-1.057.331-.274.221-.411.586-.411 1.095v2.424h-.763v-4.606h.763v.931a1.69 1.69 0 01.663-.742zM87.294 35.392a.538.538 0 01.378-.13.54.54 0 01.378.13.44.44 0 01.143.34.44.44 0 01-.143.34.538.538 0 01-.378.13.54.54 0 01-.378-.13.44.44 0 01-.143-.34c0-.14.048-.254.143-.34zm.755 1.69v4.606h-.763v-4.606h.763zM94.316 39.548h-3.683c.017.526.166.92.449 1.183.282.263.628.394 1.036.394.369 0 .678-.094.927-.281.249-.187.401-.438.457-.751h.814a1.924 1.924 0 01-1.124 1.443c-.308.14-.654.21-1.04.21a2.37 2.37 0 01-1.174-.285 2.017 2.017 0 01-.801-.818c-.193-.355-.289-.773-.289-1.254s.096-.9.289-1.258c.193-.358.46-.632.801-.822.341-.19.733-.285 1.174-.285.447 0 .837.095 1.17.285.333.19.587.445.763.763.176.319.264.671.264 1.057 0 .162-.011.302-.033.419zm-.906-1.224a1.234 1.234 0 00-.528-.512 1.608 1.608 0 00-.73-.168c-.419 0-.772.13-1.057.39-.285.26-.439.642-.461 1.145h2.945c.015-.341-.041-.626-.169-.855zM98.883 37.43c.316.271.508.636.575 1.095h-.73a1.058 1.058 0 00-.34-.675c-.193-.176-.452-.264-.776-.264-.274 0-.488.066-.642.197a.664.664 0 00-.231.533c0 .168.052.303.155.407a.984.984 0 00.386.235c.154.053.365.11.633.172.341.078.617.158.826.239.21.081.389.211.537.39.148.179.222.419.222.721 0 .375-.141.679-.424.914-.282.235-.659.352-1.128.352-.548 0-.996-.131-1.342-.394-.347-.263-.551-.629-.612-1.099h.738c.028.28.15.506.365.68.215.173.499.26.851.26.263 0 .468-.067.617-.201a.68.68 0 00.222-.529.579.579 0 00-.159-.428 1.05 1.05 0 00-.394-.243 5.673 5.673 0 00-.646-.176 6.304 6.304 0 01-.818-.235 1.252 1.252 0 01-.52-.373c-.143-.171-.214-.401-.214-.692 0-.386.143-.698.428-.935.285-.238.674-.357 1.166-.357.521-.001.939.135 1.255.406z"></path>
    </svg>
  </div>
    <div class="title">TAPAK INDUSTRIES</div>
    <div><small>www.tapakindustries.com</small></div>
    <div><small>Jl. Sawerigading, Bongki, Sinjai Utara</small></div>
    <div class="border trxid">${dataPesanan?.id || "TAPAK-XXXX-XXXX"}</div>
    <div style="width: 1in; margin: auto;">
    ${qr}
    </div>
    <div class="row">
      <div class="start">${format(new Date(), "dd MMMM yyyy", {
        locale: indo,
      })}</div>
      <div class="end">${format(new Date(), "HH:mm:ss")}</div>
    </div>
    <div class="row">
      <div class="start">Pelanggan</div>
      <div class="end">${dataPesanan?.detail?.nama || "-"}</div>
    </div>
    <div class="row">
      <div class="start">Alamat</div>
      <div class="end">${
        dataPesanan?.detail?.alamat?.slice(0, 8) + (dataPesanan?.detail?.alamat?.length > 8 ? '***' : '') || "-"
      }</div>
    </div>

    <div class="row">
    <div class="start">Admin</div>
    <div class="end">${dataPesanan?.admin || "Admin"}</div>
  </div>
    
    ${semuaPesanan}

    <div class="row total">
      <div class="start">Total</div>
      <div class="end">${new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumSignificantDigits: 10,
      }).format(total_dibayar)}</div>
    </div>
    ${pembayaran}
    <div class="pesan">
      <small>Terimakasih kak, kami tunggu pesanan selanjutnya :)</small>
    </div>
    <div class="sosmed">
      <div>
        <div style="display: flex; align-items: center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            height="1.2rem"
          >
            <rect x="0" fill="none" width="24" height="24" />
            <g>
              <path
                d="M12 4.622c2.403 0 2.688.009 3.637.052.877.04 1.354.187 1.671.31.42.163.72.358 1.035.673.315.315.51.615.673 1.035.123.317.27.794.31 1.671.043.949.052 1.234.052 3.637s-.009 2.688-.052 3.637c-.04.877-.187 1.354-.31 1.671-.163.42-.358.72-.673 1.035-.315.315-.615.51-1.035.673-.317.123-.794.27-1.671.31-.949.043-1.233.052-3.637.052s-2.688-.009-3.637-.052c-.877-.04-1.354-.187-1.671-.31a2.786 2.786 0 01-1.035-.673 2.786 2.786 0 01-.673-1.035c-.123-.317-.27-.794-.31-1.671-.043-.949-.052-1.234-.052-3.637s.009-2.688.052-3.637c.04-.877.187-1.354.31-1.671.163-.42.358-.72.673-1.035.315-.315.615-.51 1.035-.673.317-.123.794-.27 1.671-.31.949-.043 1.234-.052 3.637-.052M12 3c-2.444 0-2.751.01-3.711.054-.958.044-1.612.196-2.184.418a4.401 4.401 0 00-1.594 1.039c-.5.5-.808 1.002-1.038 1.594-.223.572-.375 1.226-.419 2.184C3.01 9.249 3 9.556 3 12s.01 2.751.054 3.711c.044.958.196 1.612.418 2.185.23.592.538 1.094 1.038 1.594s1.002.808 1.594 1.038c.572.222 1.227.375 2.185.418.96.044 1.267.054 3.711.054s2.751-.01 3.711-.054c.958-.044 1.612-.196 2.185-.418a4.411 4.411 0 001.594-1.038c.5-.5.808-1.002 1.038-1.594.222-.572.375-1.227.418-2.185.044-.96.054-1.267.054-3.711s-.01-2.751-.054-3.711c-.044-.958-.196-1.612-.418-2.185A4.411 4.411 0 0019.49 4.51c-.5-.5-1.002-.808-1.594-1.038-.572-.222-1.227-.375-2.185-.418C14.751 3.01 14.444 3 12 3zm0 4.378a4.622 4.622 0 100 9.244 4.622 4.622 0 000-9.244zM12 15a3 3 0 110-6 3 3 0 010 6zm4.804-8.884a1.08 1.08 0 10.001 2.161 1.08 1.08 0 00-.001-2.161z"
              />
            </g>
          </svg>
          <span style="margin-left: 0.5em">@tapakindustries</span>
        </div>

        <div style="display: flex; align-items: center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="1.2rem" >
            <rect x="0" fill="none" width="24" height="24" />
            <g>
              <path
                d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"
              />
            </g>
          </svg>
          <span style="margin-left: 0.5em;">Tapak Industries</span>
        </div>

        <div style="display: flex; align-items: center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            height="1.2rem"
          >
            <rect x="0" fill="none" width="24" height="24" />
            <g>
              <path
                d="M2.048 22l1.406-5.136a9.894 9.894 0 01-1.323-4.955C2.133 6.446 6.579 2 12.042 2a9.848 9.848 0 017.011 2.906 9.85 9.85 0 012.9 7.011c-.002 5.464-4.448 9.91-9.91 9.91h-.004a9.913 9.913 0 01-4.736-1.206L2.048 22zm5.497-3.172l.301.179a8.214 8.214 0 004.193 1.148h.003c4.54 0 8.235-3.695 8.237-8.237a8.189 8.189 0 00-2.41-5.828 8.182 8.182 0 00-5.824-2.416c-4.544 0-8.239 3.695-8.241 8.237a8.222 8.222 0 001.259 4.384l.196.312-.832 3.04 3.118-.819zm9.49-4.554c-.062-.103-.227-.165-.475-.289-.248-.124-1.465-.723-1.692-.806-.227-.083-.392-.124-.557.124-.165.248-.64.806-.784.971-.144.165-.289.186-.536.062-.248-.124-1.046-.385-1.991-1.229-.736-.657-1.233-1.468-1.378-1.715-.144-.248-.015-.382.109-.505.111-.111.248-.289.371-.434.124-.145.165-.248.248-.413.083-.165.041-.31-.021-.434s-.557-1.343-.763-1.839c-.202-.483-.407-.417-.559-.425-.144-.007-.31-.009-.475-.009a.91.91 0 00-.66.31c-.226.248-.866.847-.866 2.066 0 1.219.887 2.396 1.011 2.562.124.165 1.746 2.666 4.23 3.739.591.255 1.052.408 1.412.522.593.189 1.133.162 1.56.098.476-.071 1.465-.599 1.671-1.177.206-.58.206-1.075.145-1.179z"
              />
            </g>
          </svg>
          <span style="margin-left: 0.5em">0852 9847 6939</span>
        </div>
      </div>
    </div>
  </div>
</body>
</html>`;
}
